export enum ServiceStatus {
  DOWN = 'DOWN',
  IN_PROGRESS = 'IN_PROGRESS',
  LIVE = 'LIVE',
}

export const serviceStatuses = Object.values<string>(ServiceStatus);
